export default __webpack_public_path__ + "static/media/aws-route53.be950334.png";